export default __webpack_public_path__ + "static/media/checkout.8124c306.jpg";